/*
 * Manage the height of the iframe by setting a observer inside the iframe
 * and controlling the size inside bootstrap.
 */
import ResizeObserver from 'resize-observer-polyfill';

import { CheckoutIpc } from './types';

export function listenToResize(iframe: HTMLIFrameElement, ipc: CheckoutIpc) {
  ipc.listen(payload => {
    if (payload.name === 'widget_resized') {
      iframe.style.height = `${payload.data}px`;
    }
  });
}

export class ResizeSender {
  observer: ResizeObserver;

  constructor(element: Element, ipc: CheckoutIpc) {
    // Prevent accidental scroll on body.
    document.body.style.overflow = 'hidden';

    this.observer = new ResizeObserver(entries => {
      const height = entries[0].contentRect.height;

      ipc.send({ name: 'widget_resized', data: height });
    });

    this.observer.observe(element);
  }

  detach() {
    this.observer.disconnect();
  }
}
